import styled from "styled-components";
import { motion } from "framer-motion";

const LoadingScreen = () => {
  return (
    <LoadingContainer>
      <LoadingContent>
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            opacity: [1, 0.8, 1],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <h1>Chandelier Luxe</h1>
        </motion.div>
        <LoadingSpinner />
      </LoadingContent>
    </LoadingContainer>
  );
};

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: ${(props) => props.theme.colors.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const LoadingContent = styled.div`
  text-align: center;

  h1 {
    font-size: 3rem;
    color: ${(props) => props.theme.colors.accent};
    font-family: "Cormorant Garamond", serif;
    margin-bottom: 2rem;
  }
`;

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 3px solid rgba(192, 160, 128, 0.2);
  border-top: 3px solid ${(props) => props.theme.colors.accent};
  border-radius: 50%;
  margin: 0 auto;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default LoadingScreen;
